import {FC, PropsWithChildren} from "react";
import "yet-another-react-lightbox/styles.css";
import Lightbox, {Slide} from "yet-another-react-lightbox";
import Video from "yet-another-react-lightbox/plugins/video";
import {getAttachmentTypeByExtension} from "@services/helpers";
import {AttachmentType} from "@interfaces/user/support";
import {useFilesUrls} from "@hooks/filesHooks";

interface LightBoxGalleryProps {
    index: number;
    images?: string[];
    imageIds?: string[];
    setIndex: (index: number) => void;
}

const LightBoxGallery: FC<PropsWithChildren<LightBoxGalleryProps>> = ({
                                                                          index,
                                                                          setIndex,
                                                                          images = [],
                                                                          imageIds = [],
                                                                          children
}) => {

    const srcs = useFilesUrls(imageIds, images);
    const slides: Slide[] = srcs.map(src => {
        const type = getAttachmentTypeByExtension(src);
        return type === AttachmentType.Image ? { type: "image", src } : {
            type: "video",
            sources: [
                {
                    src: src,
                    type: "video/mp4"
                }
            ]
        };
    });

    return (
        <div>
            {children}
            <Lightbox
                index={index}
                slides={slides}
                open={index >= 0}
                close={() => setIndex(-1)}
            />
        </div>
    )
}

export default LightBoxGallery;